import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';

import { ActionButton } from '../../../components/ActionButton';
import { StyledDropdownOption } from '../../../components/Dropdown/styles';
import { Tooltip } from '../../../components/Tooltip';

export const StyledPreferencesButton = styled(ActionButton)`
  width: 100%;
  justify-content: center;

  ${SWReactIcons} path {
    fill-opacity: 1;
  }
`;

export const StyledPreferenceOption = styled(StyledDropdownOption)<{ height: string }>`
  display: flex;
  justify-content: space-between;
  max-height: ${({ height }) => height};
`;

export const StyledPreferenceOptionLabel = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledPreferenceTooltip = styled(Tooltip)`
  text-align: center;
`;
